import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyAddressModel, UpdateCompanyAddressModel, UpdateCompanyAddressVm } from 'src/app/models/companyAddress/company-address-model';
import { ErrorMessageModel } from 'src/app/models/customer/customer.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { CompanyAddressService } from 'src/app/services/company-address.service';

@Component({
  selector: 'app-company-address-update',
  templateUrl: './company-address-update.component.html',
  styleUrls: ['./company-address-update.component.css']
})
export class CompanyAddressUpdateComponent implements OnInit {

  updateCompanyAddress: CompanyAddressModel = new CompanyAddressModel();
  updateCompanyAddressListVm: UpdateCompanyAddressModel = new UpdateCompanyAddressModel();
  id: number;
  Loader: boolean = false;
  errorMessageModel: Array<ErrorMessageModel> = new Array<ErrorMessageModel>();
  errorMessages: ErrorMessageModel = new ErrorMessageModel();

  constructor(private alertify: AlertifyService,private companyAdress: CompanyAddressService, private route:Router,private router:ActivatedRoute) {
   }

  ngOnInit() {
    this.router.params.subscribe((param) => {
      this.id = +param.id;
    })
    this.getWarrantyServiceId();
  }
  getWarrantyServiceId() {
    this.Loader = true;
    this.companyAdress.GetCompanyAddressById(this.id)
    .subscribe((response) => {
      var responseBody = JSON.parse(response._body);
      this.updateCompanyAddressListVm = responseBody.responseData;
      this.updateCompanyAddress.Title = this.updateCompanyAddressListVm.title;
      this.updateCompanyAddress.Name = this.updateCompanyAddressListVm.name;
      this.updateCompanyAddress.City = this.updateCompanyAddressListVm.city;
      this.updateCompanyAddress.PhoneNumber = this.updateCompanyAddressListVm.phoneNumber;
      this.updateCompanyAddress.ZipCode = this.updateCompanyAddressListVm.zipCode;
      this.updateCompanyAddress.Email = this.updateCompanyAddressListVm.email;
      this.updateCompanyAddress.State = this.updateCompanyAddressListVm.state;
      this.updateCompanyAddress.Country = this.updateCompanyAddressListVm.country;
      this.updateCompanyAddress.Street = this.updateCompanyAddressListVm.street;
      this.Loader = false;
    });
  }
  
  UpdateCompanyAddress() {
    if (this.updateCompanyAddress.Title == undefined || this.updateCompanyAddress.Title == null || this.updateCompanyAddress.Title == "") {
      this.alertify.error("Title is required");
      return;
    }
    if (this.updateCompanyAddress.Name == undefined || this.updateCompanyAddress.Name == null || this.updateCompanyAddress.Name == "") {
      this.alertify.error("Name is required");
      return;
    }
    if (this.updateCompanyAddress.State == undefined || this.updateCompanyAddress.State == null || this.updateCompanyAddress.State == "") {
      this.alertify.error("State is required");
      return;
    }
    if (this.updateCompanyAddress.City == undefined || this.updateCompanyAddress.City == null || this.updateCompanyAddress.City == "") {
      this.alertify.error("City is required");
      return;
    }
    if (this.updateCompanyAddress.ZipCode == undefined || this.updateCompanyAddress.ZipCode == null || this.updateCompanyAddress.ZipCode == "") {
      this.alertify.error("ZipCode is required");
      return;
    }
    if (this.updateCompanyAddress.PhoneNumber == undefined || this.updateCompanyAddress.PhoneNumber == null || this.updateCompanyAddress.PhoneNumber == "") {
      this.alertify.error("Phone Number is required");
      return;
    }
    if (this.updateCompanyAddress.Country == undefined || this.updateCompanyAddress.Country == null || this.updateCompanyAddress.Country == "") {
      this.alertify.error("Country is required");
      return;
    }
    if (this.updateCompanyAddress.Email == undefined || this.updateCompanyAddress.Email == null || this.updateCompanyAddress.Email == "") {
      this.alertify.error("AddressNote is required");
      return;
    }
    if (this.updateCompanyAddress.Street == undefined || this.updateCompanyAddress.Street == null || this.updateCompanyAddress.Street == "") {
      this.alertify.error("Street is required");
      return;
    }
    this.updateCompanyAddress.ZipCode = this.updateCompanyAddress.ZipCode.toString();
    this.errorMessageModel = [];
    this.Loader = true;
    this.updateCompanyAddress.Id = +this.id;
     this.companyAdress.CompanyUpdateAddress(this.updateCompanyAddress)
     .subscribe((response) => {
      var responseBody = JSON.parse(response._body);
      this.Loader = false;
      if (responseBody.isSuccess) {
        this.updateCompanyAddress = responseBody.responseData;
        this.alertify.success(responseBody.responseMessage);
        this.Loader = false;
        this.route.navigate(['/company-address-listing']);
      } else {
        for(var i = 0; i < responseBody.responseData.messages.length; i++) {
          this.errorMessages = responseBody.responseData.messages[i];
          var messagesItem = new ErrorMessageModel();
          if (this.errorMessages) {
            messagesItem = this.errorMessages;
            this.errorMessageModel.push(messagesItem);
          }
          this.Loader = false;
      }
      }
     })
  }

}
